module.exports = __webpack_public_path__ + "吴杰庄-0391e0aa.png";